import React from 'react';

export default function BlackLableDetail() {
  return (
    <div className="min-h-screen bg-gray-100 p-4 md:p-8 mt-12">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-3 gap-6 items-start">

        {/* Main Content Section */}
        <div className="lg:col-span-2 space-y-6">

          {/* Section 1: Image and Content */}
          <div className="bg-white rounded-lg shadow-lg overflow-hidden">
            <div className="relative h-64 md:h-80 bg-gray-900 overflow-hidden">
              <img
                src="https://images.unsplash.com/photo-1480714378408-67cf0d13bc1f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80"
                alt="Brooklyn Bridge at night"
                className="w-full h-full object-cover filter grayscale"
              />
              <div className="absolute inset-0 bg-black bg-opacity-20"></div>
            </div>
            <div className="p-6 md:p-8">
              <h1 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">Lorem ipsum</h1>
              <p className="text-gray-600 leading-relaxed mb-6">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
              </p>
              <div className="flex justify-between text-sm text-gray-500 pt-4 border-t border-gray-200">
                <span>Category: Advertising</span>
                <span>36 comments</span>
              </div>
            </div>
          </div>

          {/* Section 2: Video */}
          <div className=" overflow-hidden p-4 flex justify-center">
            <div className="w-full max-w-[500px]">
              <video
                src="https://eskimi-creatives.com/host/Johnnie_Walker/JW_FY25_video/video_300250.mp4"
                className="w-[300px] h-[250px] object-cover"
                autoPlay
                muted
                playsInline
                loop
              ></video>
                <span>300×250</span>
                <span>ID: 1557042</span>
            </div>
          </div>

          {/* Section 4: Image and Content (Second Block) */}
          <div className="bg-white rounded-lg shadow-lg overflow-hidden">
            <div className="relative h-64 md:h-80 bg-gray-900 overflow-hidden">
              <img
                src="https://images.unsplash.com/photo-1480714378408-67cf0d13bc1f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80"
                alt="Brooklyn Bridge at night"
                className="w-full h-full object-cover filter grayscale"
              />
              <div className="absolute inset-0 bg-black bg-opacity-20"></div>
            </div>
            <div className="p-6 md:p-8">
              <h1 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">Lorem ipsum</h1>
              <p className="text-gray-600 leading-relaxed mb-6">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
              </p>
              <div className="flex justify-between text-sm text-gray-500 pt-4 border-t border-gray-200">
                <span>Category: Advertising</span>
                <span>36 comments</span>
              </div>
            </div>
          </div>
          <div className=" overflow-hidden p-4 flex justify-center">
            <div className="w-full max-w-[500px]">
              <video
                src="https://eskimi-creatives.com/host/Johnnie_Walker/JW_FY25_video/video_320480.mp4"
                className="w-[320px] h-[480px] object-cover"
                autoPlay
                muted
                playsInline
                loop
              ></video>
               <span>320×480</span>
               <span>ID: 1557042</span>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-lg overflow-hidden">
            <div className="relative h-64 md:h-80 bg-gray-900 overflow-hidden">
              <img
                src="https://images.unsplash.com/photo-1480714378408-67cf0d13bc1f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80"
                alt="Brooklyn Bridge at night"
                className="w-full h-full object-cover filter grayscale"
              />
              <div className="absolute inset-0 bg-black bg-opacity-20"></div>
            </div>
            <div className="p-6 md:p-8">
              <h1 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">Lorem ipsum</h1>
              <p className="text-gray-600 leading-relaxed mb-6">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
              </p>
              <div className="flex justify-between text-sm text-gray-500 pt-4 border-t border-gray-200">
                <span>Category: Advertising</span>
                <span>36 comments</span>
              </div>
            </div>
          </div>
        </div>

        {/* Right Sidebar */}
        <div className="space-y-6 h-fit">

          {/* Advertisement Video */}
          <div className="bg-white rounded-lg shadow-lg overflow-hidden relative min-h-[400px]">
            <video
              className="w-full h-full object-cover"
              width="300"
              height="600"
              autoPlay
              muted
              playsInline
              loop
            >
              <source
                src="https://eskimi-creatives.com/host/Johnnie_Walker/JW_FY25_video/video_300600.mp4"
                type="video/mp4"
              />
              Your browser does not support the video tag.
            </video>
            <div className="absolute bottom-4 left-4 right-4 flex justify-between text-xs text-white bg-black bg-opacity-50 px-2 py-1 rounded">
              <span>300×600</span>
              <span>ID: 1557042</span>
            </div>
          </div>

          {/* Sidebar Image Card */}
          <div className="bg-white rounded-lg shadow-lg overflow-hidden">
            <div className="relative h-48 bg-gray-900 overflow-hidden">
              <img
                src="https://images.unsplash.com/photo-1441974231531-c6227db76b6e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80"
                alt="Forest road"
                className="w-full h-full object-cover filter grayscale"
              />
              <div className="absolute inset-0 bg-black bg-opacity-20"></div>
            </div>
            <div className="p-6">
              <h2 className="text-lg font-bold text-gray-800 mb-2">ID: 1557042</h2>
              <p className="text-gray-600 text-sm leading-relaxed mb-4">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
              </p>
              <div className="flex justify-between items-center text-xs text-gray-500 pt-4 border-t border-gray-200">
                <span>Category: Advertising</span>
                <span>76 comments</span>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}


// import React from 'react';

// export default function BlackLableDetail() {
//   return (
//     <div className="min-h-screen bg-gray-100 p-4 md:p-8 mt-12">
//       <div className="max-w-7xl mx-auto">
//         <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 items-start">
//           {/* Blog Post Card */}
//           <div className="lg:col-span-2 bg-white rounded-lg shadow-lg overflow-hidden h-fit">
//             {/* Hero Image */}
//             <div className="relative h-64 md:h-80 bg-gray-900 overflow-hidden">
//               <img 
//                 src="https://images.unsplash.com/photo-1480714378408-67cf0d13bc1f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80"
//                 alt="Brooklyn Bridge at night"
//                 className="w-full h-full object-cover filter grayscale"
//               />
//               <div className="absolute inset-0 bg-black bg-opacity-20"></div>
//             </div>
            
//             {/* Content */}
//             <div className="p-6 md:p-8">
//               <h1 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
//                 Lorem ipsum
//               </h1>
              
//               <p className="text-gray-600 leading-relaxed mb-6">
//                 Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco.
//               </p>
              
//               {/* Meta Information */}
//               <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center text-sm text-gray-500 pt-4 border-t border-gray-200">
//                 <span>Category: Advertising</span>
//                 <span className="mt-2 sm:mt-0">36 comments</span>
//               </div>
//             </div>
          

//             <div className=" flex items-center justify-center  mt-8 p-4">
//       <div className="w-full max-w-[400px]">
//         <video
//           src="https://eskimi-creatives.com/host/Johnnie_Walker/JW_FY25_video/video_300250.mp4" // replace with your video path
//           className="w-full h-[250px] object-cover "
//           autoPlay 
//               muted 
//               playsInline
//               loop
//         ></video>
//       </div>
//     </div>

//             <div className="relative h-64 md:h-80 bg-gray-900 overflow-hidden">
//               <img 
//                 src="https://images.unsplash.com/photo-1480714378408-67cf0d13bc1f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80"
//                 alt="Brooklyn Bridge at night"
//                 className="w-full h-full object-cover filter grayscale"
//               />
//               <div className="absolute inset-0 bg-black bg-opacity-20"></div>
//             </div>
            
//             {/* Content */}
//             <div className="p-6 md:p-8">
//               <h1 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
//                 Lorem ipsum
//               </h1>
              
//               <p className="text-gray-600 leading-relaxed mb-6">
//                 Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco.
//               </p>
              
//               {/* Meta Information */}
//               <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center text-sm text-gray-500 pt-4 border-t border-gray-200">
//                 <span>Category: Advertising</span>
//                 <span className="mt-2 sm:mt-0">36 comments</span>
//               </div>
//             </div>

            
    
//           </div>
          
//           {/* Right Sidebar */}
//           <div className="lg:col-span-1 space-y-6 h-fit">
//             {/* Advertisement */}
//             <div className="lg:col-span-1">
//           <div className="bg-white rounded-lg shadow-lg overflow-hidden relative h-96 lg:h-full min-h-[400px]">
//             {/* Oreo Video Advertisement */}
//             <video 
//               className="w-full h-full object-cover"
//               width="300" 
//               height="600" 
//               autoPlay 
//               muted 
//               playsInline
//               loop
//             >
//               <source 
//                 src="https://eskimi-creatives.com/host/Johnnie_Walker/JW_FY25_video/video_300600.mp4" 
//                 type="video/mp4" 
//               />
//               Your browser does not support the video tag.
//             </video>
            
//             {/* Bottom Info */}
//             <div className="absolute bottom-4 left-4 right-4 flex justify-between text-xs text-white bg-black bg-opacity-50 px-2 py-1 rounded">
//               <span>300×600</span>
//               <span>ID: 1557042</span>
//             </div>
//           </div>
//         </div>

//             {/* Forest Road Content Card */}
//             <div className="bg-white rounded-lg shadow-lg overflow-hidden">
//               {/* Forest Road Image */}
//               <div className="relative h-48 bg-gray-900 overflow-hidden">
//                 <img 
//                   src="https://images.unsplash.com/photo-1441974231531-c6227db76b6e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80"
//                   alt="Forest road"
//                   className="w-full h-full object-cover filter grayscale"
//                 />
//                 <div className="absolute inset-0 bg-black bg-opacity-20"></div>
//               </div>
              
//               {/* Content */}
//               <div className="p-6">
//                 <h2 className="text-lg font-bold text-gray-800 mb-2">
//                   ID: 1557042
//                 </h2>
                
//                 <p className="text-gray-600 text-sm leading-relaxed mb-4">
//                   Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco.
//                 </p>
                
//                 {/* Meta Information */}
//                 <div className="flex justify-between items-center text-xs text-gray-500 pt-4 border-t border-gray-200">
//                   <span>Category: Advertising</span>
//                   <span>76 comments</span>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }